import LogRocket from 'logrocket'
import mixpanel from 'mixpanel-browser'

let mixpanelReady = false

export function setMixpanelReady() {
  mixpanelReady = true
}

interface UserTraits {
  email: string
  name: string
  avatar?: string
  tenantId: string
  tenantName: string
  tenantSlug: string
  tenantStatus: string
  role: string
  area?: string
  isAdmin: boolean
  isManager: boolean
  domain: string
  userAgent: string
  language: string
  timezone: string
}

type TrackValue =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | boolean[]
  | null
  | undefined
type TrackProperties = Record<string, TrackValue>

export const analytics = {
  identify(userId: string, traits: UserTraits) {
    LogRocket.identify(userId, { ...traits })

    if (mixpanelReady) {
      mixpanel.identify(userId)
      mixpanel.people.set({
        $email: traits.email,
        $name: traits.name,
        $avatar: traits.avatar,
        tenantId: traits.tenantId,
        tenantName: traits.tenantName,
        tenantSlug: traits.tenantSlug,
        tenantStatus: traits.tenantStatus,
        role: traits.role,
        area: traits.area,
        isAdmin: traits.isAdmin,
        isManager: traits.isManager,
      })
      mixpanel.register({
        userName: traits.name,
        tenantId: traits.tenantId,
        tenantSlug: traits.tenantSlug,
        tenantName: traits.tenantName,
        role: traits.role,
        area: traits.area,
        isAdmin: traits.isAdmin,
        isManager: traits.isManager,
      })
    }
  },

  track(event: string, properties?: TrackProperties) {
    LogRocket.track(event, properties)
    if (mixpanelReady) {
      mixpanel.track(event, properties)
    }
  },

  captureException(error: Error, extra?: Record<string, string>) {
    LogRocket.captureException(error, { extra })
  },
}
